<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>项目</el-breadcrumb-item>
        <el-breadcrumb-item>分销推广</el-breadcrumb-item>
        <el-breadcrumb-item>帮助中心</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">帮助中心</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="HelpTextCreateDialog = true"
          >创建文章</el-button>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">文章列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            align="center"
            width="400"
          >
            <template slot-scope="scope">
              <div style="text-align:left;">{{scope.row.title}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="category_ids"
            label="分类"
            align="center"
          >
            <template slot-scope="scope">{{
            formateCategory(scope.row.category_ids)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="修改时间"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="openHelpTextEditDialog(scope.row)"
              >编辑</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <HelpTextCreate
      :visible="HelpTextCreateDialog"
      @close="HelpTextCreateDialog=false"
      @submit="fetchList()"
    />
    <HelpTextEdit
      :visible="HelpTextEditDialog"
      @close="HelpTextEditDialog=false"
      :content="HelpTextEditContent"
      @submit="fetchList()"
    />
  </div>

</template>

<script>

import { helpArticlelist, helpArticledelete } from "@/api/distribution";
import HelpTextCreate from '@/components/dialog/distribution/HelpTextCreate.vue'
import HelpTextEdit from '@/components/dialog/distribution/HelpTextEdit.vue'

export default {
  components: {
    HelpTextCreate,
    HelpTextEdit
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      HelpTextCreateDialog: false,
      HelpTextEditDialog: false,
      HelpTextEditContent: {}
    };
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      helpArticlelist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handleToRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        helpArticledelete({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchList()
        })
      }).catch(() => { })
    },
    openHelpTextEditDialog(row) {
      this.HelpTextEditContent = JSON.parse(JSON.stringify(row))
      this.HelpTextEditDialog = true
    },
    formateCategory(id) {
      const obj = {
        1: "热门问题",
        2: "客户关系问题",
        3: "业绩统计问题",
      };
      return obj[id] || "无"
    }
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
